export const shouldAutoCalculateKeyInitiativeEstimateSales = (
  initialEstimateSales?: number | null,
  isManuallyEdited?: boolean
): boolean => (isManuallyEdited === undefined ? initialEstimateSales == null : !isManuallyEdited)
